import store from '../store'

export default function auth(to, from, next) {
  const user = store.getters['auth/admin']

  const ignoreLoginRoutes = ['admin.login']

  if (!ignoreLoginRoutes.includes(to.name)) {
    if (user) {
      if (user.roles.includes('admin') || user.roles.includes('super-admin')) {
        next()
      } else {
        next({ name: 'admin.login', query: to.query })
      }
    } else {
      next({ name: 'admin.login' })
    }
  } else {
    next()
  }
}
